var ObserverManager = /** @class */ (function () {
    function ObserverManager() {
        this.entries = [];
    }
    ObserverManager.prototype.add = function (el, callback) {
        this.entries.push({ el: el, callback: callback });
        observer.observe(el);
    };
    ObserverManager.prototype.remove = function (entry) {
        var index = this.entries.indexOf(entry);
        this.entries.splice(index, 1);
    };
    ObserverManager.prototype.intersect = function (el) {
        var entry = this.entries.find(function (entry) { return entry.el === el; });
        if (entry) {
            entry.callback();
            this.remove(entry);
        }
    };
    ObserverManager.prototype.isSupported = function () {
        return !(!('IntersectionObserver' in window) ||
            !('IntersectionObserverEntry' in window) ||
            !('intersectionRatio' in window.IntersectionObserverEntry.prototype));
    };
    return ObserverManager;
}());
var manager = new ObserverManager;
var observer = {
    observe: function (element) {
        manager.intersect(element);
    }
};
if (manager.isSupported()) {
    observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                manager.intersect(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });
}
export default manager;
